import {
  createContext,
  useContext,
  useState,
  useSyncExternalStore,
  type ReactNode,
} from "react";
import {
  createConversationDraftStore,
  type ConversationDraftEntry,
  type ConversationDraftStore,
} from "./conversation-draft-store.js";

const ConversationDraftStoreContext = createContext<ConversationDraftStore | null>(null);

/**
 * Lives under InboxPage (`key={organizationId}`), so org switches
 * destroy the in-memory map. Drafts are session-only; refresh is out of scope.
 */
export function ConversationDraftProvider({
  children,
}: {
  children: ReactNode;
}): React.JSX.Element {
  const [store] = useState(() => createConversationDraftStore());
  return (
    <ConversationDraftStoreContext.Provider value={store}>
      {children}
    </ConversationDraftStoreContext.Provider>
  );
}

export function useConversationDraftStore(): ConversationDraftStore {
  const store = useContext(ConversationDraftStoreContext);
  if (store == null) {
    throw new Error("useConversationDraftStore requires ConversationDraftProvider");
  }
  return store;
}

export function useConversationDraftSnapshot(): ReadonlyMap<number, ConversationDraftEntry> {
  const store = useConversationDraftStore();
  return useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
}
